import type {FC} from 'react';

import {Observer} from 'mobx-react';

import type {TrackersStore} from '../../../../../stores/Trackers/Trackers.store';
import type {OnMoreIconClick} from '../../types';

import MoreIcon from '../../../../../../../../assets/icons/secondary/More.svg';
import {Clickable} from '../../../../../../../../uikit/Clickable';
import {Icon} from '../../../../../../../../uikit/Icon';
import {Text} from '../../../../../../../../uikit/Text';
import {Option} from '../../../../../../ui/components/Option';
import {WeightChart} from '../../../../../../ui/components/WeightChart';
import * as S from '../../styles';
import {TestID} from '../../test_ids';

type Props = {
  onMoreReportingClick: (e: Parameters<OnMoreIconClick>[0]) => void;
  store: TrackersStore;
  t: (key: string) => string;
};

export const ReportingBlock: FC<Props> = ({onMoreReportingClick, store, t}) => (
  <Observer>
    {() => (
      <S.ReportingBlock $isExpanded={store.isWeightHistoryBlockVisible}>
        <S.Row>
          <Text variant="h3" weight="bold">
            {t('shared:progress')}
          </Text>
          <S.OptionsWrapper>
            {store.isWeightHistoryBlockVisible ? (
              <S.OptionsContainer>
                {store.weightUnitOptions.map(({isSelected, label, value}) => (
                  <Option
                    isSelected={isSelected}
                    key={value}
                    label={label}
                    onClick={() => store.setSelectedUnit(value)}
                    width={69}
                  />
                ))}
              </S.OptionsContainer>
            ) : null}
            <Clickable
              onClick={onMoreReportingClick}
              testID={TestID.button_more_reporting}
            >
              <Icon color="icon.gray" svg={MoreIcon} />
            </Clickable>
          </S.OptionsWrapper>
        </S.Row>
        {store.isWeightHistoryBlockVisible ? (
          <>
            <S.OptionsContainer>
              {store.periodOptions.map(({isSelected, label, value}) => (
                <Option
                  isSelected={isSelected}
                  key={value}
                  label={label}
                  onClick={() => store.setSelectedPeriod(value)}
                />
              ))}
            </S.OptionsContainer>
            <S.ChartContainer>
              <WeightChart
                metrics={store.metrics}
                period={store.selectedPeriod}
                unit={store.selectedUnit}
              />
            </S.ChartContainer>
          </>
        ) : null}
      </S.ReportingBlock>
    )}
  </Observer>
);
